import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { FRAES } from 'src/app/core/constants/fraes-api';
import { environment } from 'src/environments/environment';
import { MatFlexLine } from '../../models/materials/mat-flex-line.model';

@Injectable()
export class FlexLineImporterService {
  structureBaseUrl: string;

  constructor(private httpClient: HttpClient) {
    this.structureBaseUrl = `${environment.fraes_url}/structure`;
  }

  migrateProperty(
    sourceObj: any,
    destObj: any,
    sourceKey: string,
    destKey: string,
    convertionFactor = 1.0,
  ) {
    if (
      sourceObj?.hasOwnProperty(sourceKey) &&
      sourceObj[sourceKey]?.value !== null &&
      sourceObj[sourceKey]?.value !== undefined
    ) {
      destObj[destKey] = sourceObj[sourceKey]?.value * convertionFactor;
    }
  }

  fraesStructureToMatFlexLine(fraesStructure: any): MatFlexLine {
    const matToReturn = new MatFlexLine();
    const props = fraesStructure?.props;
    if (!props) {
      return matToReturn;
    }

    this.migrateProperty(
      props,
      matToReturn,
      FRAES.STRUCTURE.EXTERNAL_DIAMETER_KEY,
      'externalDiameter',
      0.001,
    );
    this.migrateProperty(
      props,
      matToReturn,
      FRAES.STRUCTURE.INTERNAL_DIAMETER_KEY,
      'internalDiameter',
      0.0254,
    );
    this.migrateProperty(
      props,
      matToReturn,
      FRAES.STRUCTURE.DRY_WEIGHT_KEY,
      'weightDry',
      0.00980665,
    );
    this.migrateProperty(
      props,
      matToReturn,
      FRAES.STRUCTURE.WET_WEIGHT_KEY,
      'weightWet',
      0.00980665,
    );
    this.migrateProperty(
      props,
      matToReturn,
      FRAES.STRUCTURE.AXIAL_STIFFENESS_KEY,
      'stiffAxial',
      1.0,
    );
    this.migrateProperty(
      props,
      matToReturn,
      FRAES.STRUCTURE.TORSIONAL_STIFFENESS_KEY,
      'stiffTorsional',
      0.001,
    );
    this.migrateProperty(
      props,
      matToReturn,
      FRAES.STRUCTURE.BENDING_STIFFENESS_KEY,
      'stiffBending',
      1.0,
    );
    return matToReturn;
  }

  fetchFlexlineMaterials(): Observable<any> {
    const materialList = `${this.structureBaseUrl}/list`;
    return this.httpClient.get(materialList);
  }

  getMaterialFromId(materialId: number): Observable<MatFlexLine> {
    const materialUrl = `${this.structureBaseUrl}/${materialId}`;
    return this.httpClient
      .get(materialUrl)
      .pipe(map((x) => this.fraesStructureToMatFlexLine(x)))
      .pipe(catchError((error) => throwError(error)));
  }
}
